<template>
  <div
    class="config-form-content adminWeeducAdvanced adminWeeducConfig weeduc-admin-config weeduc-admin-advanced"
  >
    <div class="weeduc-admin-advanced__intro">
      <h3 class="weeduc-admin-advanced__title">{{ $t('admin.siteConfig.advancedTitle') }}</h3>
      <p class="weeduc-admin-advanced__lead">
        {{ $t('admin.siteConfig.advancedLead') }}
      </p>
    </div>

    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0" v-if="hasReady">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">{{ $t('admin.siteConfig.ecommerceSection') }}</h3>
          <p class="weeduc-admin-config-section-lead">
            {{ $t('admin.siteConfig.ecommerceSectionLead') }}
          </p>

          <div class="form-group weeduc-admin-advanced-field">
            <v-select
              v-model="typeLayoutPortalEcommerce"
              :items="themeOptions"
              item-title="text"
              item-value="value"
              :label="$t('admin.siteConfig.ecommerceTheme')"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">{{ $t('admin.siteConfig.ecommerceThemeHint') }}</small>
            <div class="theme-description mt-2 weeduc-admin-advanced-theme-hint">
              <p class="mb-1">
                <strong>Clean:</strong>
                {{ $t('admin.siteConfig.cleanDesc') }}
              </p>
              <p class="mb-0">
                <strong>Dark:</strong>
                {{ $t('admin.siteConfig.darkDesc') }}
              </p>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducAdvancedCss">{{ $t('admin.siteConfig.customCss') }}</label>
            <textarea
              id="weeducAdvancedCss"
              class="form-input weeduc-admin-advanced-textarea"
              v-model="css"
              rows="8"
              :placeholder="$t('admin.siteConfig.cssPlaceholder')"
            />
            <small class="form-small-description">{{ $t('admin.siteConfig.customCssHint') }}</small>
            <small class="form-small-description weeduc-admin-advanced-alert">
              {{ $t('admin.siteConfig.cssWarning') }}
            </small>
          </div>

          <div class="form-group">
            <v-select
              v-model="contentWarning"
              :items="contentWarningOptions"
              item-title="text"
              item-value="value"
              :label="$t('admin.siteConfig.sensitiveContent')"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">{{ $t('admin.siteConfig.sensitiveContentHint') }}</small>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">{{ $t('admin.siteConfig.portalSection') }}</h3>
          <p class="weeduc-admin-config-section-lead">
            {{ $t('admin.siteConfig.portalSectionLead') }}
          </p>

          <div class="form-group weeduc-admin-advanced-field">
            <v-select
              v-model="typeLayoutPortalStudent"
              :items="themeOptions"
              item-title="text"
              item-value="value"
              :label="$t('admin.siteConfig.portalTheme')"
              variant="outlined"
              class="filter-form-control inputd weeduc-admin-v-field"
              :menu-props="adminSelectMenuProps"
              density="compact"
              hide-details
            />
            <small class="form-small-description">{{ $t('admin.siteConfig.portalThemeHint') }}</small>
            <div class="theme-description mt-2 weeduc-admin-advanced-theme-hint">
              <p class="mb-1">
                <strong>Clean:</strong>
                {{ $t('admin.siteConfig.cleanDesc') }}
              </p>
              <p class="mb-0">
                <strong>Dark:</strong>
                {{ $t('admin.siteConfig.darkDesc') }}
              </p>
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducAdvancedJs">{{ $t('admin.siteConfig.customJs') }}</label>
            <textarea
              id="weeducAdvancedJs"
              class="form-input weeduc-admin-advanced-textarea"
              v-model="js"
              rows="8"
              :placeholder="$t('admin.siteConfig.jsPlaceholder')"
            />
            <small class="form-small-description">{{ $t('admin.siteConfig.customJsHint') }}</small>
            <small class="form-small-description weeduc-admin-advanced-alert">
              {{ $t('admin.siteConfig.jsWarning') }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <Loader :isActive="hasReady" />

    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end">
        <button type="button" class="btn btn-block btn-content" @click="save()" :disabled="loading">
          <span v-if="!loading">{{ $t('admin.siteConfig.savePublish') }}</span>
          <span v-else class="d-inline-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            {{ $t('admin.siteConfig.saving') }}
          </span>
        </button>
        <button type="button" class="btn btn-block btn-content" @click="clearCache()" :disabled="loading">
          <span v-if="!loading">{{ $t('admin.siteConfig.clearCache') }}</span>
          <span v-else class="d-inline-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            {{ $t('admin.siteConfig.pleaseWait') }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import apiSiteAdvanced from '@/utils/Site/advanced'
import Loader from '@/components/Loader/loader.vue'
import websiteApi from '@/utils/Weflix/website'
import companyApi from '@/utils/company'
import { toast } from 'vue3-toastify'

export default {
  name: 'AdminWeeducAdvanced',
  components: {
    Loader,
  },
  data() {
    return {
      typeLayoutPortalEcommerce: '',
      typeLayoutPortalStudent: '',
      contentWarning: '',
      infoCompany: {},
      css: '',
      js: '',
      loading: false,
      hasReady: true,
      
    }
  },
  computed: {
    ...mapState(['token', 'dark']),

    themeOptions() {
      return [
        { text: this.$t('common.select'), value: '' },
        { text: 'Dark', value: '0' },
        { text: 'Clean', value: '1' },
      ]
    },
    contentWarningOptions() {
      return [
        { text: this.$t('common.select'), value: '' },
        { text: this.$t('common.yes'), value: '1' },
        { text: this.$t('common.no'), value: '0' },
      ]
    },
    adminSelectMenuProps() {
      return this.dark ? { contentClass: 'weeduc-admin-select-menu-dark' } : {}
    },
  },
  methods: {
    async getAdvancedData() {
      try {
        const response = await apiSiteAdvanced.getAdvancedData(this.token)
        this.typeLayoutPortalEcommerce =
          response.typeLayout !== undefined && response.typeLayout !== null
            ? String(response.typeLayout)
            : ''
        this.typeLayoutPortalStudent =
          response.typeLayoutPortal !== undefined && response.typeLayoutPortal !== null
            ? String(response.typeLayoutPortal)
            : ''
        this.contentWarning =
          response.contentWarning !== undefined && response.contentWarning !== null
            ? String(response.contentWarning)
            : ''
        this.css = response.css || ''
        this.js = response.javascript || ''
        this.hasReady = true
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.advancedLoadError'))
        console.error('Erro ao obter dados avançados:', error)
      }
    },
    async getInfoCompany() {
      try {
        const response = await companyApi.getInfoCompany(this.token)
        this.infoCompany = response
        this.contentWarning =
          response.ageRestricted !== undefined && response.ageRestricted !== null
            ? String(response.ageRestricted)
            : ''
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.companyLoadError'))
      }
    },
    async setInfoCompany() {
      try {
        const payload = {
          ...this.infoCompany,
          ageRestricted: this.contentWarning !== '' ? parseInt(this.contentWarning, 10) : null,
        }
        await companyApi.setInfoCompany(this.token, payload)
        toast.success(this.$t('admin.siteConfig.companySaveSuccess'))
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.companySaveError'))
        console.error('Erro ao salvar dados da empresa:', error)
      }
    },
    async save() {
      this.loading = true
      this.hasReady = false
      const payload = {
        typeLayout:
          this.typeLayoutPortalEcommerce !== '' ? parseInt(this.typeLayoutPortalEcommerce, 10) : null,
        typeLayoutPortal:
          this.typeLayoutPortalStudent !== '' ? parseInt(this.typeLayoutPortalStudent, 10) : null,
        contentWarning: this.contentWarning !== '' ? parseInt(this.contentWarning, 10) : null,
        css: this.css,
        javascript: this.js,
      }
      try {
        await apiSiteAdvanced.putAdvancedData(this.token, payload)
        if (this.contentWarning !== '') {
          await this.setInfoCompany()
        }
        await this.clearCache({ silent: true })
        await this.getAdvancedData()
        await this.getInfoCompany()
        toast.success(this.$t('admin.siteConfig.advancedSaveSuccess'))
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.advancedSaveError'))
        console.error('Erro ao salvar dados avançados:', error)
      } finally {
        this.hasReady = true
        this.loading = false
      }
    },
    async clearCache(options = {}) {
      const silent = options.silent === true
      try {
        await websiteApi.clearCache(this.token)
        if (!silent) {
          toast.success(this.$t('admin.siteConfig.cacheCleared'))
        }
      } catch (error) {
        toast.error(this.$t('admin.siteConfig.cacheError'))
        console.error('Erro ao limpar cache', error)
      }
    },
  },
  created() {
    this.getAdvancedData()
    this.getInfoCompany()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/config.css';
@import '@/css/weeduc/admin/advanced.css';
</style>
